module.exports = __webpack_public_path__ + "img/buessiness_hy_c1.38dad333.png";